import type {Box, PropsOf} from '@chakra-ui/react';
import {useColorMode, useTheme} from '@chakra-ui/react';
import {resolveStyleConfig} from '@chakra-ui/styled-system';
import {ChakraAside} from '@linx-security/ui/utils/chakra-elements';

import {StylesProvider, useStyles} from './context';
import {sidebarTheme} from './theme/theme';

export type Props = PropsOf<typeof Box>;

const NavInternal = ({children, ...props}: Props) => {
  const {container: style} = useStyles();

  return (
    <ChakraAside as={`aside`} role={`menu`} __css={style} {...props}>
      {children}
    </ChakraAside>
  );
};

export const Nav = (props: Props) => {
  const theme = useTheme();
  const {colorMode} = useColorMode();
  const styles = resolveStyleConfig(sidebarTheme)({theme, colorMode});

  return (
    <StylesProvider value={styles}>
      <NavInternal {...props} />
    </StylesProvider>
  );
};
export type {Props as NavProps};
